import { render, staticRenderFns } from "./H5Detail.vue?vue&type=template&id=e46c747e&scoped=true"
import script from "./H5Detail.vue?vue&type=script&lang=js"
export * from "./H5Detail.vue?vue&type=script&lang=js"
import style0 from "./H5Detail.vue?vue&type=style&index=0&id=e46c747e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46c747e",
  null
  
)

export default component.exports